// src/context/ModalContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  openModal: (modalId: string) => void;
  closeModal: () => void;
  activeModal: string | null;
  isOverlayVisible: boolean;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const openModal = (modalId: string) => {
    setIsOverlayVisible(true);
    setActiveModal(modalId);
  };

  const closeModal = () => {
    setIsOverlayVisible(false);
    setActiveModal(null);
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal, activeModal, isOverlayVisible }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};